<template>
  <section class="w-full">
    <!--
      =========================================================
      SECCIÓN 1: 2 BLOQUES (Aditivo / Tipos)
      - Mobile: imagen -> texto
      - Desktop: alterna (texto/imagen, imagen/texto)
      =========================================================
    -->
    <div :class="clases_contenedor_blanco">
        <!-- OJO: quitamos space-y-* para que NO meta margin entre bloques -->
        <div class="w-full max-w-[1400px] mx-auto">
            <div
            v-for="bloque in bloques_intro"
            :key="bloque.id"
            class="grid grid-cols-1 md:grid-cols-2"
            >
            <!-- Imagen (SIEMPRE primero en DOM para mobile) -->
            <div
                :class="[
                'w-full bg-no-repeat bg-center bg-contain md:bg-right md:bg-cover',
                bloque.alto_clase,
                clase_columna_imagen(bloque.invertir_en_desktop)
                ]"
                :style="{ backgroundImage: `url(${bloque.imagen})` }"
                role="img"
                :aria-label="bloque.alt"
            />

            <!-- Texto -->
            <div
                :class="[
                'flex flex-col justify-center',
                'pt-4 pb-4 md:pt-4 md:pb-4',
                'md:p-[100px]',
                clase_columna_texto(bloque.invertir_en_desktop)
                ]"
            >
                <h2 class="font-bold text-[18px] md:text-[32px] leading-tight text-black">
                {{ bloque.titulo }}
                </h2>

                <p class="mt-3 text-[16px] md:text-[16px] leading-[18px] md:leading-[20px] text-black/60 max-w-[44rem]">
                {{ bloque.texto }}
                </p>
            </div>
            </div>
        </div>
    </div>


    <!--
      =========================================================
      SECCIÓN 2: GRIS - "Principales aditivos para el combustible"
      - Desktop: 2 columnas
      - Mobile: 1 columna
      =========================================================
    -->
    <div :class="clases_contenedor_gris">
      <div class="flex flex-col items-center max-w-[1400px] mx-auto">
        <div class="flex items-start justify-center gap-2 text-center">
          <img
            src="/img/fluidos/vector_negro.png"
            alt=""
            width="20"
            height="26"
            class="mt-[2px] h-[26px] w-[20px]"
            loading="lazy"
            decoding="async"
          />
          <h2 class="font-semibold text-[32px] md:text-[32px] leading-snug text-black">
            Aquí te contamos los principales aditivos para el combustible
          </h2>
        </div>

        <h3 class="mt-4 text-center text-[28px] md:text-[28px] text-black/70">
          Sus principales funciones son:
        </h3>
      </div>

      <!-- Lista -->
      <div class="mt-8 grid grid-cols-1 md:grid-cols-2 gap-y-6 md:gap-y-10 md:gap-x-16 max-w-[1400px] mx-auto">
        <div
          v-for="item in items_combustible"
          :key="item.id"
          class="flex items-center gap-4"
        >
          <img
            :src="item.icono"
            :alt="item.alt"
            class="h-[44px] w-[44px] md:h-[48px] md:w-[48px] shrink-0"
            loading="lazy"
            decoding="async"
          />

          <p class="text-[16px] md:text-[28px] leading-[16px] md:leading-[28px] text-black/70">
            {{ item.titulo }}
          </p>
        </div>
      </div>

      <!-- Separador + Nota -->
      <div class="mt-8 max-w-[1400px] mx-auto">
        <div class="h-px  w-max-[1400px] bg-black/55"></div>
        <p class="mt-3 text-center text-[12px] md:text-[16px] leading-[14px] md:leading-[16px] text-black/55">
          Los combustibles, tanto la gasolina como el diésel, tienen agentes corrosivos y también incluyen partículas sólidas
          que terminan acumulándose en el motor y en otras partes, como los inyectores. Todo ello, además de reducir la vida útil
          de dichas piezas, resta rendimiento al vehículo. Los aditivos buscan reducir o eliminar dicho efecto.
        </p>
      </div>
    </div>

    <!--
      =========================================================
      SECCIÓN 3: 2 BLOQUES (Limpieza / Lubricantes)
      - Mobile: imagen -> texto
      - Desktop: alterna (texto/imagen, imagen/texto)
      =========================================================
    -->
    <div :class="clases_contenedor_blanco">
      <div class="w-full max-w-[1400px] mx-auto">
        <div
          v-for="bloque in bloques_limpieza_lubricantes"
          :key="bloque.id"
          class="grid grid-cols-1 md:grid-cols-2"
        >
          <!-- Imagen (mobile primero) -->
          <div
            :class="[
              ' w-max-[1400px] bg-no-repeat bg-center bg-contain md:bg-right md:bg-cover',
              bloque.alto_clase,
              clase_columna_imagen(bloque.invertir_en_desktop)
            ]"
            :style="{ backgroundImage: `url(${bloque.imagen})` }"
            role="img"
            :aria-label="bloque.alt"
          />

          <!-- Texto -->
          <div
            :class="[
              'flex flex-col justify-center',              
              'pt-4 pb-4 md:pt-4 md:pb-4',
              'md:p-[100px]',
              clase_columna_texto(bloque.invertir_en_desktop)
            ]"
          >
            <h2 class="font-bold text-[18px] md:text-[32px] leading-tight text-black">
              {{ bloque.titulo }}
            </h2>

            <p class="mt-3 text-[16px] md:text-[16px] leading-[18px] md:leading-[20px] text-black/60 max-w-[44rem]">
              {{ bloque.texto }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!--
      =========================================================
      SECCIÓN 4: GRIS - Funciones aditivos para lubricantes (lista vertical)
      =========================================================
    -->
    <div :class="clases_contenedor_gris">
      <div class="flex items-start justify-center gap-2 text-center max-w-[1400px] mx-auto">
        <img
          src="/img/fluidos/vector_negro.png"
          alt=""
          width="20"
          height="26"
          class="mt-[2px] h-[26px] w-[20px]"
          loading="lazy"
          decoding="async"
        />
        <h2 class="font-semibold text-[32px] md:text-[32px] leading-snug text-black">
          En términos generales, las funciones principales de<br />
          los aditivos para lubricantes son:
        </h2>
      </div>

      <div class="mt-8 space-y-6 md:space-y-8 max-w-[1400px] mx-auto">
        <div
          v-for="item in items_lubricantes"
          :key="item.id"
          class="flex items-start gap-4"
        >
          <img
            :src="item.icono"
            :alt="item.alt"
            class="h-[44px] w-[44px] md:h-[48px] md:w-[48px] shrink-0"
            loading="lazy"
            decoding="async"
          />
          <p class="pt-[2px] text-[16px] md:text-[28px] leading-[16px] md:leading-[28px] text-black/70">
            {{ item.titulo }}
          </p>
        </div>
      </div>
    </div>

    <!--
      =========================================================
      SECCIÓN 5: Refrigeración (título + 2 bloques)
      - Mobile: imagen -> texto
      - Desktop: alterna (texto/imagen, imagen/texto)
      =========================================================
    -->
    <div :class="clases_contenedor_blanco">
      <div class="flex items-start justify-center gap-2 text-center max-w-[1400px] mx-auto">
        <img
          src="/img/fluidos/vector_negro.png"
          alt=""
          width="20"
          height="26"
          class="mt-[2px] h-[26px] w-[20px]"
          loading="lazy"
          decoding="async"
        />
        <h2 class="font-semibold text-[32px] md:text-[32px] leading-snug text-black">
          Aditivos para el sistema de refrigeración
        </h2>
      </div>

      <div class="mt-8 space-y-10 md:space-y-12 max-w-[1400px] mx-auto">
        <div
          v-for="bloque in bloques_refrigeracion"
          :key="bloque.id"
          class="grid grid-cols-1 md:grid-cols-2"
        >
          <!-- Imagen (mobile primero) -->
          <div
            :class="[
              ' w-max-[1400px] bg-no-repeat bg-center bg-contain md:bg-right md:bg-cover',
              bloque.alto_clase,
              clase_columna_imagen(bloque.invertir_en_desktop)
            ]"
            :style="{ backgroundImage: `url(${bloque.imagen})` }"
            role="img"
            :aria-label="bloque.alt"
          />

          <!-- Texto -->
          <div
            :class="[
              'flex flex-col justify-center',
              'pt-6 md:pt-0',
              'md:p-[100px]',
              clase_columna_texto(bloque.invertir_en_desktop)
            ]"
          >
            <p class="text-[16px] md:text-[16px] leading-[18px] md:leading-[20px] text-black/60 max-w-[46rem]">
              {{ bloque.texto }}
            </p>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script setup>
// =============================================================
// Componente: Landing Aditivos (Higienización)
// Objetivo: replicar pixel-perfect (desktop y mobile) desde Laravel/Bootstrap
// Restricción: un solo archivo, sin depender de estilos externos.
// =============================================================

// -------------------------
// Helpers de orden (ROBUSTO)
// -------------------------
// Nota importante:
// - "order-*" funciona perfecto siempre que el contenedor sea grid/flex (acá es grid).
// - Mobile: imagen siempre primero (order base)
// - Desktop: se invierte usando md:order-* según bandera invertir_en_desktop
const clase_columna_imagen = (invertir_en_desktop) => {
  return invertir_en_desktop
    ? 'order-1 md:order-2'
    : 'order-1 md:order-1'
}

const clase_columna_texto = (invertir_en_desktop) => {
  return invertir_en_desktop
    ? 'order-2 md:order-1'
    : 'order-2 md:order-2'
}

// -------------------------
// Contenedores (paddings legacy)
// - Mobile: 20px
// - Desktop “medio”: 130px (>= xl)
// - Desktop grande: 190px (>= 2xl)
// -------------------------
const clases_contenedor_blanco =
  'bg-white px-5 xl:px-[130px] 2xl:px-[190px] py-[30px] md:py-[70px]'

const clases_contenedor_gris =
  'bg-[#F1F2F2] px-5 xl:px-[130px] 2xl:px-[190px] py-[30px] md:py-[70px]'

// -------------------------
// Datos (contenido legacy)
// -------------------------
const bloques_intro = [
  {
    id: 'aditivo',
    titulo: '¿Qué es un aditivo?',
    texto:
      'Un aditivo es un producto químico que se agrega a uno o más fluidos del automóvil con el objetivo final de mejorar el rendimiento del mismo y proteger las piezas que lo conforman.',
    imagen: '/img/fluidos/img1.jpg',
    alt: 'Imagen de aceite vertiéndose',
    alto_clase: 'h-[200px] sm:h-[220px] md:h-[360px]',
    invertir_en_desktop: true
  },
  {
    id: 'tipos',
    titulo: '¿Qué tipos de aditivos hay?',
    texto:
      'Los tipos de aditivos son variados y numerosos y no todos tienen la misma función ni se utilizan del mismo modo.',
    imagen: '/img/fluidos/img2.jpg',
    alt: 'Imagen de pistones con fluido',
    alto_clase: 'h-[200px] sm:h-[220px] md:h-[360px]',
    invertir_en_desktop: false
  }
]


const items_combustible = [
  {
    id: 'comb_1',
    icono: '/img/fluidos/ico1.png',
    alt: 'Icono lubricación y limpieza',
    titulo: 'Lubricación y limpieza de la bomba y los inyectores'
  },
  {
    id: 'comb_2',
    icono: '/img/fluidos/ico2.png',
    alt: 'Icono menor consumo',
    titulo: 'Menor consumo de combustible'
  },
  {
    id: 'comb_3',
    icono: '/img/fluidos/ico3.png',
    alt: 'Icono reducción ruido',
    titulo: 'Reducción del ruido del motor'
  },
  {
    id: 'comb_4',
    icono: '/img/fluidos/ico4.png',
    alt: 'Icono mejor aceleración',
    titulo: 'Mejor respuesta de aceleración'
  },
  {
    id: 'comb_5',
    icono: '/img/fluidos/ico5.5.png',
    alt: 'Icono reducción emisiones',
    titulo: 'Reducción de las emisiones contaminantes'
  },
  {
    id: 'comb_6',
    icono: '/img/fluidos/ico5.png',
    alt: 'Icono anticongelación',
    titulo: 'Anticongelación'
  },
  {
    id: 'comb_7',
    icono: '/img/fluidos/ico6.png',
    alt: 'Icono aumento potencia',
    titulo: 'Aumento de la potencia del motor'
  },
  {
    id: 'comb_8',
    icono: '/img/fluidos/ico7.png',
    alt: 'Icono efecto limpieza',
    titulo: 'Efecto de limpieza en el motor'
  }
]

const bloques_limpieza_lubricantes = [
  {
    id: 'limpieza',
    titulo: 'Aditivos de limpieza',
    texto:
      'Si bien los aditivos incorporados al combustible cumplen esta función, existen aditivos específicamente diseñados para limpiar los inyectores y la válvula EGR (Exhaust Gas Recirculation). Ambos se añaden al depósito del combustible, pero existen productos específicos para gasolina y diésel.',
    imagen: '/img/fluidos/img3.jpg',
    alt: 'Imagen relacionada a aditivos de limpieza',
    alto_clase: 'h-[200px] sm:h-[220px] md:h-[360px]',
    // Desktop: texto izquierda, imagen derecha
    invertir_en_desktop: true
  },
  {
    id: 'lubricantes',
    titulo: 'Aditivos para Lubricantes',
    texto:
      'Estos aditivos se encargan de mejorar el rendimiento del lubricante base. Potencian las propiedades que ya existen en el mismo o le añaden otras complementarias, suprimiendo las que no son válidas.',
    imagen: '/img/fluidos/img4.jpg',
    alt: 'Imagen relacionada a aditivos para lubricantes',
    alto_clase: 'h-[200px] sm:h-[220px] md:h-[360px]',
    // Desktop: imagen izquierda, texto derecha
    invertir_en_desktop: false
  }
]

const items_lubricantes = [
  {
    id: 'lub_1',
    icono: '/img/fluidos/ico8.png',
    alt: 'Icono evitar oxidación',
    titulo: 'Evitar la oxidación del aceite para que no se produzcan daños en la maquinaria.'
  },
  {
    id: 'lub_2',
    icono: '/img/fluidos/ico9.png',
    alt: 'Icono ralentizar desgaste',
    titulo: 'Ralentizar el desgaste, el bloqueo de los filtros u otros efectos negativos.'
  },
  {
    id: 'lub_3',
    icono: '/img/fluidos/ico10.png',
    alt: 'Icono mejorar fluidez',
    titulo: 'Mejorar la fluidez del lubricante.'
  },
  {
    id: 'lub_4',
    icono: '/img/fluidos/ico11.png',
    alt: 'Icono proteger motor',
    titulo: 'Proteger el motor de combustiones o posibles fallas del lubricante.'
  }
]

const bloques_refrigeracion = [
  {
    id: 'ref_1',
    texto:
      'Los aditivos para la refrigeración en los vehículos están especialmente recomendados para aquellos motores con muchos años o que hayan estado inactivos por un tiempo prolongado.',
    imagen: '/img/fluidos/img5.jpg',
    alt: 'Imagen sistema de refrigeración',
    // Legacy: padding 90px 0 => altura aproximada 180px
    alto_clase: 'h-[180px] sm:h-[200px] md:h-[220px]',
    // Desktop: texto izquierda, imagen derecha
    invertir_en_desktop: true
  },
  {
    id: 'ref_2',
    texto:
      'Estos aditivos se fabrican con componentes que limpian profundamente todas las impurezas, como la suciedad, el óxido y las incrustaciones. Además, descubren posibles fugas en el sistema.\n\nEn cualquier caso, ninguno de estos productos sustituye la mantención periódica de un auto, la sustitución de las piezas de desgaste o los trabajos de reparación. Su función es mejorar las prestaciones o retrasar el deterioro.',
    imagen: '/img/fluidos/img6.jpg',
    alt: 'Imagen líquido refrigerante',
    alto_clase: 'h-[180px] sm:h-[200px] md:h-[220px]',
    // Desktop: imagen izquierda, texto derecha
    invertir_en_desktop: false
  }
]
</script>
